import { render, staticRenderFns } from "./QuadrilleRightBackground.vue?vue&type=template&id=28b1a51b"
import script from "./QuadrilleRightBackground.vue?vue&type=script&lang=js"
export * from "./QuadrilleRightBackground.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../admin/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports